import AreasAccessGrid from "../../../shared/components/AreasAccessGrid";
import { stockAreas } from "../constants/stockAreas";

export default function StockSectionsGrid({
  areas = stockAreas,
  onAreaClick,
  title,
}) {
  return (
    <AreasAccessGrid
      areas={areas}
      onAreaClick={onAreaClick}
      title={title}
    />
  );
}
